export default function () {
  return {
    filter: {
      description: '',
    },
  };
}
